module.exports = __webpack_public_path__ + "img/videomask.5617c5c5.png";